import type { EnumType } from "@pdfking/structs"

export const CreateRepr = <Name extends string, T extends Record<string, unknown> = {}>(
  name: Name,
  context?: T
): EnumType<Name, T> => (context ? { enum: name, ...context } : { enum: name }) as EnumType<Name, T>
